document.addEventListener('DOMContentLoaded', () => {
  const departmentSections = document.querySelectorAll('.departments__box');
  const sideMenuItems = document.querySelectorAll('.departments__table-title .side-title__item');

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const activeIndex = Array.from(departmentSections).indexOf(entry.target);

        sideMenuItems.forEach((menuItem, index) => {
          if (index === activeIndex) {
            menuItem.classList.add('active');
          } else {
            menuItem.classList.remove('active');
          }
        });
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });

  departmentSections.forEach((section) => sectionObserver.observe(section));
});

// ビジネス
document.addEventListener('DOMContentLoaded', () => {
  const departmentSections = document.querySelectorAll('.business__box');
  const sideMenuItems = document.querySelectorAll('.departments__table-title .side-title__item');

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const activeIndex = Array.from(departmentSections).indexOf(entry.target);

        sideMenuItems.forEach((menuItem, index) => {
          if (index === activeIndex) {
            menuItem.classList.add('active');
          } else {
            menuItem.classList.remove('active');
          }
        });
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });

  departmentSections.forEach((section) => sectionObserver.observe(section));
});


// 制度紹介
$(function(){
  $('.introduction__open').on('click', function() {
    $(this).prev('.introduction__content').find('.introduction__hiden').slideToggle();
    $(this).toggleClass('active');
  });
});




// メインビジュアルのテキストアニメーション処理
// mv__heading__textクラスの要素が画面内に表示されたら、
// 1秒後にactiveクラスを追加してアニメーションを実行する
$(function(){
  $('.mv__heading__text').on('inview', function(event, isInView) {
      if (isInView) {
          setTimeout(() => {
              $(this).addClass('active');
          }, 2600);
      }
  });
});



$(function(){
    $('.opacity02').css('opacity', '0');
    $('.mv__box__item').on('inview', function(event, isInView) {
        if (isInView) {
            setTimeout(() => {
                $(this).addClass('active');
                setTimeout(() => {
                    $('.opacity02').animate({
                        'opacity': '1'
                    }, 1500); // フェードインを1秒で完了
                }, 1000); // クラス付与1秒後にフェードインを実行
            }, 2600); // 画面に入ってから3秒後にクラス付与
        }
    });
});

// プロセス

$(function () {
  function updateMargins() {
    $('.process__item').each(function () {
      const processBody = $(this).find('.process__body');
      const bodyHeight = processBody.outerHeight();

      if (!$(this).hasClass('active')) {
        $(this).css('margin-bottom', `-${bodyHeight}px`);
      } else {
        $(this).css('margin-bottom', 'unset');
      }
    });
  }

  // タイトルクリック時の処理
  $('.process__title').on('click', function () {
    $('.process__items').slideToggle();
    $('.icon-plus').toggleClass('active');
    updateMargins();
  });

  // 各アイテムクリック時の処理
  const items = $('.process__item');
  items.on('click', function () {
    const clickedItem = $(this);
    const processBody = clickedItem.find('.process__body');
    const bodyHeight = processBody.outerHeight();

    // 既にアクティブなアイテムをクリックした場合
    if (clickedItem.hasClass('active')) {
      // アクティブ状態を解除
      clickedItem.removeClass('active')
                .css('margin-bottom', `-${bodyHeight}px`);
      clickedItem.find('.process__icon').removeClass('active');
      // 全てのアイテムからdisabledクラスを削除
      items.removeClass('disabled');
      return;
    }

    // それ以外の場合は他のアイテムを閉じて、クリックしたアイテムを開く
    items.removeClass('active')
         .addClass('disabled')
         .css('margin-bottom', function () {
           const otherBodyHeight = $(this).find('.process__body').outerHeight();
           return `-${otherBodyHeight}px`;
         });
    $('.process__icon').removeClass('active');

    clickedItem.addClass('active')
              .removeClass('disabled')
              .css('margin-bottom', 'unset');
    clickedItem.find('.process__icon').addClass('active');
  });

  // 初期状態のマージン設定
  updateMargins();
});


// header


$(function(){
    $('#drawer-button').on('click', function(){
        $(this).toggleClass('active');
        $('#drawer-menu').toggleClass('active');
        $('#drawer-overlay').toggleClass('active');
        
        if ($('#drawer-menu').hasClass('active')) {
            $('body').css('overflow', 'hidden');
        } else {
            $('body').css('overflow', '');
        }
    });
});


$(function(){
    $('#drawer-overlay').on('click', function(){
        $('#drawer-button').removeClass('active');
        $('#drawer-menu').removeClass('active');
        $(this).removeClass('active');
        $('body').css('overflow', ''); // ここでbodyのoverflowを解除
    });
});


// ヘッダーフェードイン

// $(function() {
  
//   $('.page--page #header-typeB, .header-entry').hide();

//   $(window).scroll(function() {
    
//     const underTopElement = $('.under-top');
//     if(underTopElement.length) {
//       const underTopBottom = underTopElement.offset().top + underTopElement.outerHeight();
//       const scrollTop = $(window).scrollTop();

      
//       if(scrollTop > underTopBottom) {
//         $('.page--page #header-typeB, .header-entry').fadeIn();
//       } else {
//         $('.page--page #header-typeB, .header-entry').fadeOut();
//       }
//     }
//   });
// });


// ビジネス
document.addEventListener('DOMContentLoaded', () => {
  const businessGroups = document.querySelectorAll('.business__group');
  const sideMenuItems = document.querySelectorAll('.departments__table-title .side-title__item');

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const activeIndex = Array.from(businessGroups).indexOf(entry.target);

        sideMenuItems.forEach((menuItem, index) => {
          if (index === activeIndex) {
            menuItem.classList.add('active');
          } else {
            menuItem.classList.remove('active');
          }
        });
      }
    });
  }, {
    root: null,
    rootMargin: '0px', 
    threshold: 0.5,
  });

  businessGroups.forEach((group) => sectionObserver.observe(group));
});



$(function() {
  $('.sp-close').on('click', function() {
    $(this).toggleClass('active');
    $('#drawer-menu').toggleClass('active');
    $('#sp-drawer').toggleClass('active');
    if($(this).hasClass('active')) {
      $('body').css('position', 'fixed');
    } else {
      $('body').css('position', 'static');
    }
  });
});

// カウントアップ
document.addEventListener("DOMContentLoaded", function() {
  const counters = document.querySelectorAll('.number__info--big');

  const options = {
      root: null, 
      rootMargin: '-50px',
      threshold: 0.5
  };

  const callback = (entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              const counter = entry.target;
              const target = +counter.getAttribute('data-count');

              if (target === 0) {
                  counter.style.display = 'none';
                  observer.unobserve(counter);
                  return;
              }

              let startTime;
              const duration = 1000; // 1秒でカウントアップ

              const updateCount = (currentTime) => {
                  if (!startTime) startTime = currentTime;
                  const elapsed = currentTime - startTime;
                  const progress = Math.min(elapsed / duration, 1);

                  const currentCount = Math.ceil(progress * target);
                  counter.innerText = currentCount;

                  if (progress < 1) {
                      requestAnimationFrame(updateCount);
                  } else {
                      counter.innerText = target;
                  }
              };

              requestAnimationFrame(updateCount);
              observer.unobserve(counter);
          }
      });
  };

  const observer = new IntersectionObserver(callback, options);

  counters.forEach(counter => {
      observer.observe(counter);
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const moreButtons = document.querySelectorAll('.under-about__more');
  
  moreButtons.forEach(button => {
    button.addEventListener('click', () => {
      const missionText = button.previousElementSibling;
      const span = button.querySelector('span');
      
      // トグルスライドの実装
      missionText.classList.toggle('active');
      const isExpanding = missionText.classList.contains('active');
      
      if (isExpanding) {
        missionText.style.height = `${missionText.scrollHeight}px`;
        span.textContent = '閉じる';
      } else {
        missionText.style.height = '210px';
        span.textContent = '開く';
      }
      
      button.classList.toggle('active');
    });
  });
});


$(".hasChildren")
  .on("mouseenter", function () {
    // マウスが乗ったとき
    $(this).children("a").addClass("open"); // 子要素の<a>に openクラスを付与
    $(this).children("ul,.megaMenu").addClass("open"); // 子要素の<ul>や .megaMenu に openクラスを付与
  })
  .on("mouseleave", function () {
    // マウスが外れたとき
    $(this).children("a").removeClass("open"); 
    $(this).children("ul,.megaMenu").removeClass("open");
  });
